import { render } from "./PoliciesIndex.vue?vue&type=template&id=6e2b5150"
import script from "./PoliciesIndex.vue?vue&type=script&lang=js"
export * from "./PoliciesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__